import i18n from 'i18next'
import k from './../i18n/keys'
import React from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const BaseLayout = React.forwardRef(
  ({ children, bgcolor = 'white', ...props }, ref) => {
    const theme = useTheme()
    const xl = useMediaQuery(theme.breakpoints.only('xl'))
    const lg = useMediaQuery(theme.breakpoints.only('lg'))
    const md = useMediaQuery(theme.breakpoints.only('md'))
    const sm = useMediaQuery(theme.breakpoints.only('sm'))
    const xs = useMediaQuery(theme.breakpoints.only('xs'))
    let px = 0

    if (xl) {
      px = props.px && props.px.xl ? props.px.xl : 'calc((100% - 1160px) / 2)'
    } else if (lg) {
      px = props.px && props.px.lg ? props.px.lg : 'calc((100% - 1160px) / 2)'
    } else if (md) {
      px = props.px && props.px.md ? props.px.md : 'calc(0.298 * 100% - 289px)'
    } else if (sm || xs) {
      px = i18n.t(k.PX7)
    }
    return (
      <Box
        width='100%'
        display='flex'
        flexDirection='column'
        alignItems='center'
        bgcolor={bgcolor}
        px={px}
        ref={ref}
        {...props}
      >
        {children}
      </Box>
    )
  }
)

export default BaseLayout
